exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skeleton-d-locus .skel-d-locus-row-alpha[data-v-441ac7c6]{margin-bottom:.25rem}.skeleton-d-locus .skel-d-locus-row-beta[data-v-441ac7c6]{display:flex;align-items:center;margin-bottom:.275rem}.skeleton-d-locus .skel-d-locus-row-beta .skel-d-locus-row-beta-l[data-v-441ac7c6]{flex:1 1 60%}.skeleton-d-locus .skel-audit[data-v-441ac7c6]{display:flex;align-items:center}.skeleton-d-locus .skel-audit .skel-audit-profile[data-v-441ac7c6]{margin-right:.275rem}", ""]);

// exports
